var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"calendar-time-line",style:({
      'top': _vm.nowPos + 'px'
    })},[_c('div',{staticClass:"calendar-time-line-label"},[_vm._v(_vm._s(_vm.now))]),_c('div',{staticClass:"calendar-time-line-border"})])
}
var staticRenderFns = []

export { render, staticRenderFns }